import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PAGE_KEY } from "./constants";
var localeEs = /*#__PURE__*/_defineProperty({}, PAGE_KEY, {
  LABEL_SELECT_CATEGORY: 'Seleccionar categoría: {{name}}'
});
export default localeEs;